import React, { Component } from "react";

import { Row, Col } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import Responsive from "react-responsive";

// JS Files
import HomePageMenu from "../../MainComponents/HomePageCom/HomePageMenu.js";
import Companies from "../../MainComponents/HomePageCom/Companies.js";
import Slider from "../../MainComponents/HomePageCom/Slider.js";
import Services from "../../MainComponents/HomePageCom/Services.js";
import Introduction from "../../MainComponents/HomePageCom/Introduction.js";
import Statistics from "../../MainComponents/HomePageCom/Statistics.js";
import Gallery from "../../MainComponents/HomePageCom/Gallery.js";
import Clients from "../../MainComponents/HomePageCom/Clients.js";
import Footer from "../../MainComponents/CommonCom/Footer.js";
import SandoghKeshavarzi from "../../MainComponents/HomePageCom/SandoghKeshavarzi.js";

// Mount Files
import { TextAutoplay } from "../../Statics/HomePage/TextAutoplay.js";
import { MobileHPMenu } from "../../Statics/HomePage/MobileHPMenu.js";
import DownloadApps from "../../MainComponents/HomePageCom/DownloadApps.js";
import SandoghKhesarat from "../../MainComponents/HomePageCom/SandoghKhesarat.js";
import Khesarat from "../../MainComponents/HomePageCom/Khesarat.js";

// Responsive Part
const Desktop = (props) => <Responsive {...props} minWidth={1441} />;
const Laptop = (props) => (
  <Responsive {...props} minWidth={769} maxWidth={1440} />
);
const Tablet = (props) => (
  <Responsive {...props} minWidth={426} maxWidth={768} />
);
const Mobile = (props) => <Responsive {...props} maxWidth={425} />;

class HomePage extends Component {
  componentDidMount = () => {
    TextAutoplay();
  };
  render() {
    return (
      <div>
        <Mobile>
          <div>
            <HomePageMenu history={this.props.history} />
            <Companies />
            <Margin top={3}></Margin>
            <Row>
              <Col span={1}></Col>
              <Col span={22}>
                <Slider />
              </Col>
              <Col span={1}></Col>
            </Row>
            <Margin top={3}></Margin>
            <Services history={this.props.history} />
            <Introduction />
            <Statistics />
            <Margin top={3}></Margin>
            <Gallery />
            <Margin top={3}></Margin>
            <Khesarat/>
            <SandoghKhesarat  />

          <SandoghKeshavarzi  />
          <Margin top={3}></Margin>
          <Clients  />
          <Margin top={3}></Margin>
            <DownloadApps />
            <Footer history={this.props.history} />
          </div>
        </Mobile>
        <Tablet>
          <div className="homePageBackground">
            <HomePageMenu size="tablet" history={this.props.history} />
            <Margin top={3}></Margin>
            <Companies size="tablet" />
          </div>
          <Row style={{ marginTop: "-25px" }}>
            <Col span={2}></Col>
            <Col span={20}>
              <Slider size="tablet" />
            </Col>
            <Col span={2}></Col>
          </Row>
          <Margin top={4}></Margin>
          <Services size="tablet" history={this.props.history} />
          <Margin top={2}></Margin>
          <Introduction size="tablet" />
          <Statistics size="tablet" />
          <Margin top={4}></Margin>
          <Gallery size="tablet" />
          <Margin top={3}></Margin>
          <Khesarat size="tablet"/>
          <SandoghKhesarat size="tablet"  />
          <SandoghKeshavarzi size="tablet"  />

          <Margin top={3}></Margin>
          <Clients size="tablet"  />
          <Margin top={3}></Margin>
          <DownloadApps size="tablet" />
          <Footer size="tablet" history={this.props.history} />
        </Tablet>
        <Laptop>
          <div className="homePageBackground">
            <HomePageMenu size="laptopdesktop" history={this.props.history} />
            <Companies size="laptopdesktop" />
            <div style={{ marginTop: "125px" }}>
              <Center>
                <Slider size="laptopdesktop" />
              </Center>
            </div>
          </div>
          <Services size="laptopdesktop" history={this.props.history} />
          <Margin top={5}></Margin>
          <Introduction size="laptopdesktop" />
          <Statistics size="laptopdesktop" />
          <Margin top={3}></Margin>
          <Gallery size="laptopdesktop" />
          
          <Margin top={3}></Margin>
          <Khesarat size="laptopdesktop"/>
          <SandoghKhesarat size="laptopdesktop" />
          <SandoghKeshavarzi size="laptopdesktop" />

          <Margin top={3}></Margin>
          <Clients size="laptopdesktop" />
          <Margin top={3}></Margin>
          <DownloadApps size="laptopdesktop" />
          <Footer size="laptopdesktop" history={this.props.history} />
        </Laptop>
        <Desktop>
          <div className="homePageBackground">
            <HomePageMenu size="laptopdesktop" history={this.props.history} />
            <Companies size="laptopdesktop" />
            <Row style={{ marginTop: "300px" }}>
              <Col span={4}></Col>
              <Col span={16}>
                <Slider size="laptopdesktop" />
              </Col>
              <Col span={4}></Col>
            </Row>
          </div>
          <Services size="laptopdesktop" history={this.props.history} />
          <Margin top={5}></Margin>
          <Introduction size="laptopdesktop" />
          <Statistics size="laptopdesktop" />
          <Margin top={3}></Margin>
          <Gallery size="laptopdesktop" />
          <Margin top={3}></Margin>
          <Clients size="laptopdesktop" />
          <Margin top={3}></Margin>
          <DownloadApps size="laptopdesktop" />
          <Margin top={3}></Margin>
          <Khesarat size="laptopdesktop"/>
          <SandoghKhesarat size="laptopdesktop" />
          <SandoghKeshavarzi size="laptopdesktop" />

          <Footer size="laptopdesktop" history={this.props.history} />
        </Desktop>
      </div>
    );
  }
}
export default HomePage;
